import { useState, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useGlobalContext } from "../GlobalContext";

export default function useBank() {
  const { baseurl, token, AdminId, setIsUnauthorised } = useGlobalContext();

  const [banks, setBanks] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchBanks = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseurl}/api/Driver/v1.0/getBankList`,
        { userid: "" },
        { headers: { Authorization: `Basic ${token}` } }
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setBanks(response.data.data || []);
      } else if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error fetching banks");
    } finally {
      setLoading(false);
    }
  }, [baseurl, token, setIsUnauthorised]);

  const addDriverBank = async (form) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseurl}/api/Driver/v1.0/insertDriverBankDetails`,
        form,
        { headers: { Authorization: `Basic ${token}` } }
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        await fetchBanks();
        return true;
      } else if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(response.data.responseMessage);
      }
      return false;
    } catch (error) {
      toast.error("Error adding bank details");
      return false;
    } finally {
      setLoading(false);
    }
  };

  const deleteDriverBank = async (bankId) => {
    if (!bankId) {
      toast.error("Invalid bank ID");
      return false;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${baseurl}/api/Driver/v1.0/deleteDriverBankDetails`,
        { bankId },
        { headers: { Authorization: `Basic ${token}` } }
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        await fetchBanks();
        return true;
      } else if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(response.data.responseMessage);
      }
      return false;
    } catch (error) {
      toast.error("Error deleting bank details");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    banks,
    drivers,
    loading,
    fetchBanks,
    addDriverBank,
    deleteDriverBank,
  };
}
